export const globalSettingSuccessMsg = (globalSettingIdent: string) => {
  if (globalSettingIdent === "global_unit_attribute_map") {
    return "Successfully updated default unit attributes";
  }

  if (globalSettingIdent === "global_robots") {
    return "Successfully updated robots.txt file";
  }

  return "Your changes have been saved";
};
